/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerModel } from '../../models/practitioner-model';

export interface ConsumerGet$Params {
}

export function consumerGet(http: HttpClient, rootUrl: string, params?: ConsumerGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<PractitionerModel>> {
  const rb = new RequestBuilder(rootUrl, consumerGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PractitionerStrictHttpResponse<PractitionerModel>;
    })
  );
}

consumerGet.PATH = '/Consumer';
